/* Numa — Add to Cart (shared across all pages) → opens UpCart-style drawer */
(function() {
  'use strict';

  var VARIANT_ID = 45829973737633;

  function fallbackAdd(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    })
    .then(function(res) { if (!res.ok) throw new Error('Add to cart failed'); return res.json(); })
    .then(function() { sessionStorage.setItem('numa_open_cart', '1'); window.location.reload(); });
  }

  function addToCart(variantId, qty) {
    var id = variantId || VARIANT_ID;
    /* Split OS price test: arm B adds the $69.99 twin (snippets/numa-price-arm.liquid) */
    if (typeof window.numaPillowId === 'function') id = window.numaPillowId(id);
    var quantity = qty || 1;
    /* Prefer the drawer's inline add (no reload); fall back to reload-then-open */
    if (window.numaCartDrawer && typeof window.numaCartDrawer.addItem === 'function') {
      return window.numaCartDrawer.addItem(id, quantity);
    }
    return fallbackAdd(id, quantity);
  }

  function handleClick(e) {
    e.preventDefault();
    var btn = e.currentTarget;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    var qty = 1;
    var activeOption = document.querySelector('.pp-pricing-option.is-active, .numa-buybox__option.is-active, .bb__option.is-active');
    if (activeOption) {
      var optQty = parseInt(activeOption.getAttribute('data-qty'), 10);
      if (optQty > 0) qty = optQty;
    }

    Promise.resolve(addToCart(VARIANT_ID, qty))
      .then(function() { btn.textContent = originalText; btn.disabled = false; })
      .catch(function() { btn.textContent = originalText; btn.disabled = false; });
  }

  var selectors = [
    '.numa-hero__cta',
    '.numa-buybox__cta',
    '.bb__cta',
    '.numa-sticky-bar__cta',
    '.pp-cta',
    '.pp-guarantee-cta',
    '.pp-sticky-cta',
    '.cross-atc'
  ];

  selectors.forEach(function(sel) {
    document.querySelectorAll(sel).forEach(function(btn) {
      btn.addEventListener('click', handleClick);
    });
  });
})();
